import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspRatecardSettingService {

  constructor(private http: HttpClient) { }

    addLabourItem(payload: any): Observable<any> {
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/labour/add`, payload);
  }
  editLabourItem(payload: any): Observable<any> {
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/labour/edit`, payload);
}
getGarageLabourRateCard(garageKey: string): Observable<any> {
  return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/garage/garageLabourRateCard/${garageKey}`);
}

}
